import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useBackgroundStore } from "@/stores/background";

const DEFAULT_KEY_FLAG = "MTE4P0RGJ";

export function useKeyFlag() {
  const route = useRoute();
  const router = useRouter();
  const backgroundStore = useBackgroundStore();

  // 原始 keyFlag：
  // - 优先从路由路径段取（/:keyFlag?/xxx）
  // - 若没有，则从 URL 查询串取（如 ?ak=xxx 或 ?keyFlag=xxx）
  // - 若仍没有，返回空字符串（避免在路由/查询参数尚未就位时就发请求）
  const currentKeyFlag = computed((): string => {
    const fromRoute = route.params.keyFlag;
    if (typeof fromRoute === "string" && fromRoute) return fromRoute;

    if (typeof window !== "undefined") {
      const search = new URLSearchParams(window.location.search);
      const fromQuery =
        search.get("ak") ||
        search.get("keyFlag") ||
        search.get("keyflag");
      if (fromQuery) return fromQuery;
    }

    return "";
  });

  // 对外统一使用的 ak（缺失时回退默认值）
  const ak = computed((): string => {
    return currentKeyFlag.value || DEFAULT_KEY_FLAG;
  });

  // 初始化 keyFlag
  function initKeyFlag() {
    backgroundStore.setKeyFlag(ak.value);
    return ak.value;
  }

  // 跳转时保留 keyFlag
  function navigateWithKeyFlag(path: string) {
    const flag = ak.value;
    // 如果路径不以 / 开头，加上 /
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    // 构建新路径：/keyFlag/path
    const newPath = `/${flag}${normalizedPath === "/" ? "" : normalizedPath}`;
    return router.push(newPath);
  }

  // 构建带 keyFlag 的路径
  function getPathWithKeyFlag(path: string): string {
    const flag = ak.value;
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `/${flag}${normalizedPath === "/" ? "" : normalizedPath}`;
  }

  return {
    currentKeyFlag,
    ak,
    initKeyFlag,
    navigateWithKeyFlag,
    getPathWithKeyFlag,
  };
}
